var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3201 18.97C10.4601 19.08 10.6001 19.18 10.7501 19.29C11.8901 20.12 13.0401 20.78 14.1901 21.27C15.3401 21.76 16.4301 22 17.4501 22C18.1501 22 18.8001 21.87 19.4001 21.62C20.0101 21.37 20.5501 20.98 21.0401 20.44C21.3301 20.12 21.5501 19.78 21.7201 19.42C21.8901 19.06 21.9701 18.69 21.9701 18.33C21.9701 18.05 21.9101 17.8 21.8101 17.55C21.7001 17.3 21.5201 17.09 21.2601 16.91L17.9501 14.56C17.7001 14.39 17.4701 14.26 17.2501 14.17C17.0301 14.08 16.8301 14.04 16.6401 14.04C16.3901 14.04 16.1601 14.11 15.9301 14.25C15.7001 14.37 15.4601 14.56 15.2101 14.81L14.4501 15.56C14.3401 15.67 14.2101 15.73 14.0401 15.73C13.9501 15.73 13.8701 15.72 13.7901 15.69C13.7201 15.66 13.6601 15.63 13.6101 15.61C13.4201 15.51 13.2001 15.37 12.9601 15.19",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.73 13.22C10.21 12.69 9.73 12.16 9.28 11.64C8.84 11.12 8.53 10.69 8.35 10.36C8.33 10.3 8.3 10.24 8.27 10.16C8.25 10.08 8.24 10.01 8.24 9.93C8.24 9.77 8.29 9.64 8.4 9.53L9.16 8.74C9.4 8.5 9.59 8.26 9.72 8.03C9.86 7.8 9.93 7.56 9.93 7.32C9.93 7.13 9.88 6.92 9.79 6.71C9.7 6.49 9.57 6.26 9.39 6.01L7.07 2.74C6.89 2.48 6.66 2.3 6.4 2.18C6.15 2.06 5.87 2 5.59 2C4.85 2 4.15 2.31 3.51 2.94C2.98 3.44 2.6 4 2.36 4.61C2.12 5.21 2 5.86 2 6.54C2 7.58 2.24 8.67 2.72 9.81C3.2 10.94 3.86 12.08 4.68 13.22C5.51 14.36 6.44 15.45 7.47 16.49",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2L2 22",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallSlash);
export default ForwardRef;